import UnitsContainer, { UnitsContainerProps } from './UnitsContainer';

export default UnitsContainer;
export type { UnitsContainerProps };
